const AUTH_STORAGE_KEY_ID = process.env.NEXT_PUBLIC_APP_ABBREVIATION || 'COMMON';

export const AuthStorageKeys = {
  ACCESS_TOKEN: `PHOENIX_AUTH_${AUTH_STORAGE_KEY_ID}_ACCESS_TOKEN`,
  CODE_VERIFIER: `PHOENIX_AUTH_${AUTH_STORAGE_KEY_ID}_CODE_VERIFIER`,
  ID_TOKEN: `PHOENIX_AUTH_COMMON_ID_TOKEN`,
  STATE: `PHOENIX_AUTH_${AUTH_STORAGE_KEY_ID}_STATE`,
  CSRF: `PHOENIX_AUTH_${AUTH_STORAGE_KEY_ID}_CSRF`,
  REFRESH_TOKEN: `PHOENIX_AUTH_${AUTH_STORAGE_KEY_ID}_REFRESH_TOKEN`,
  USER_INFO: `PHOENIX_AUTH_COMMON_USER_INFO`,
  AUTH_STATE: `PHOENIX_AUTH_COMMON_AUTH_STATE`,
};

export interface AuthResponse {
  access_token: string;
  expires_in: number;
  expires_on: number;
  id_token: string;
  id_token_expires_in: number;
  not_before: number;
  profile_info: string;
  refresh_token: string;
  refresh_token_expires_in: number;
  resource: string;
  scope: string;
  token_type: string;
}

export interface PkceParams {
  codeChallenge: string;
  codeVerifier: string;
  state: string;
  csrf: string;
}

/**
 * Response that is returned by the UserInfo endpoint.
 * => https://login.stihl(-preview).com/stihlid[preview|production].onmicrosoft.com/b2c_1a_production_flow_signin/openid/v2.0/userinfo
 *
 * Returned values are based on the token's scopes.
 */
export interface UserInfoResponseDto {
  // requires the `openid` scope
  stihl_id: string; // 38211ecd-8a23-4fee-9f0e-fe7756796510
  name: string; // Edythe Wiza
  // requires the `profile` scope
  given_name: string; // Edythe
  family_name: string; // Wiza
  locale: string; // de-DE
  country: string; // DE
  // requires the `email` scope
  email: string; // max.mustermann@stihl.de
  email_verified: string; // false
  // requires the `phone` scope
  phone_number: string; // +49408233908
  phone_number_verified: string; // true
  // requires the `address` scope
  address: string; // 1896 Wanda River\n21790 South Jimm
}

export interface UserInfo extends UserInfoResponseDto {
  anonymousId: string;
}
